














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Moment from 'moment'
import Timezone from 'moment-timezone'
import { NumberMixin, DashboardMixin } from '@finx/web-repository/src/mixin/_'

@Component({
  mixins: [NumberMixin, DashboardMixin],
})

export default class ComponentDashboardOperadora extends Vue {
  @Prop(Boolean) exibirValores
  @Prop(Array) dataset

  returnStyle(model, index) {
    let style = `width: ${model.porcentagem}%;`

    if (index === 0) style += 'border-top-left-radius: 5px;border-bottom-left-radius: 5px;border-right: 1px #fff solid;'

    if (index === this.dataset.length - 1) style += 'border-top-right-radius: 5px;border-bottom-right-radius: 5px;'

    else style += 'border-right: 1px #fff solid;'

    // @ts-ignore
    return `${style}; background-color: ${this.cor(index)};"`
  }
}
